import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview } from '../../config/posthog';

const PageViewTracker = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        capturePageview();
    }, [pathname]);

    return null;
};

export default PageViewTracker;
